import { actionClearMsg, actionDeleteAllProductWishListSuccess, actionDeleteProductWishListSuccess, actionSetWishYN, countPdtWishListSuccess, delPdtWishListSuccess, loadPdtWishListSuccess, savePdtWishListSuccess } from "@app/actions/shoppingmall/wishlist-pdt.action";
import { ValidationUtil } from "@app/common/util/validation.util";
import { OrdPdtModel } from "@app/models/shoppingmall/order-pdt.model";
import { PdtWishListState } from "@app/selectors/shoppingmall/wishlist-pdt-selector";
import { createReducer } from "@ngrx/store";
import { on } from "@ngrx/store";

export const pdtWishListFeatureKey = "pdtWishList";

export const initialState: PdtWishListState = {
    total: 0,
    items: [] as OrdPdtModel[],
    msg: "",
    msgDeleteWishList : new Map<String, String>,
	productWishYN: {} as Map<string, string>
}

export const pdtWishListReducer = createReducer(
    initialState,
    on(loadPdtWishListSuccess, (state, { items }) => ({...state, items : items})),
    on(countPdtWishListSuccess, (state, { total }) => ({...state, total : total})),
    on(savePdtWishListSuccess, (state, { msg }) => ({...state, msg: msg})),
    on(delPdtWishListSuccess, (state, { msg }) => ({...state, msg: msg})),
    on(actionDeleteProductWishListSuccess, (state, { msgDeleteWishList }) => ({...state, msgDeleteWishList: msgDeleteWishList})),
    on(actionDeleteAllProductWishListSuccess, (state, { msgDeleteWishList }) => ({...state, msgDeleteWishList: msgDeleteWishList})),
    on(actionClearMsg, (state, { msgDeleteWishList }) => ({...state, msgDeleteWishList: msgDeleteWishList})),
	on(actionSetWishYN, (state, { pdtCd, wishYn }) => {
	        const updatedMap = new Map();
	        if(ValidationUtil.isNotNullAndNotEmpty(pdtCd)) {
	            updatedMap.set(pdtCd, wishYn);
	            return { ...state, productWishYN: updatedMap };
	        } else {
	            return {...state}
	        }
    })
)
